const ledgerAccountCategoryTypes = {
  BALANCE_SHEET: 'BALANCE_SHEET',
  INCOME_STATEMENT: 'INCOME_STATEMENT',
};

export default ledgerAccountCategoryTypes;
